/** The URL-backed location of an interview quote on an authenticated study page. */
export interface QuoteDeepLinkTarget {
  sessionId: string;
  turnIndex: number | null;
}

export interface QuoteDeepLinkSearch {
  tab: "conversations";
  session: string;
  turn?: number;
}

/** Coerce a URL search value to the transcript's 0-based turn index. */
export function parseQuoteTurnIndex(value: unknown): number | null {
  const parsed =
    typeof value === "number"
      ? value
      : typeof value === "string" && /^\d+$/.test(value)
        ? Number(value)
        : Number.NaN;
  return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : null;
}

/** Read a quote target from route search params. A turn without a session is not a target. */
export function parseQuoteDeepLink(search: Record<string, unknown>): QuoteDeepLinkTarget | null {
  if (typeof search.session !== "string" || search.session.length === 0) return null;
  return {
    sessionId: search.session,
    turnIndex: parseQuoteTurnIndex(search.turn),
  };
}

/** Build the search fragment used by links back to an interview quote. */
export function quoteDeepLinkSearch(target: {
  sessionId: string;
  turnIndex?: number | null;
}): QuoteDeepLinkSearch {
  const turn = parseQuoteTurnIndex(target.turnIndex);
  return {
    tab: "conversations",
    session: target.sessionId,
    ...(turn != null ? { turn } : {}),
  };
}
